export default __webpack_public_path__ + "src/assets/unruly_logo.png";